import { type ReactNode, type SVGProps } from 'react'

type FlagCode = 'cz' | 'ua' | 'us'

type FlagProps = {
  code: FlagCode
  size?: number
} & SVGProps<SVGSVGElement>

const FLAGS: Record<FlagCode, ReactNode> = {
  cz: (
    <>
      <rect fill="#fff" height="16" rx="2" width="22" x="1" y="4" />
      <path d="M1 12h22v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-6Z" fill="#d7141a" />
      <path d="m1.6 5.5 9.4 6.5-9.4 6.5A2 2 0 0 1 1 17V7a2 2 0 0 1 .6-1.5Z" fill="#11457e" />
    </>
  ),
  ua: (
    <>
      <path d="M1 6a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v6H1V6Z" fill="#005bbb" />
      <path d="M1 12h22v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-6Z" fill="#ffd500" />
    </>
  ),
  us: (
    <>
      <rect fill="#fff" height="16" rx="2" width="22" x="1" y="4" />
      <path
        d="M1 6.4h22M1 8.9h22M1 11.4h22M1 13.9h22M1 16.4h22"
        stroke="#b22234"
        strokeWidth="1.6"
      />
      <path d="M1 6a2 2 0 0 1 2-2h9v8H1V6Z" fill="#3c3b6e" />
    </>
  ),
}

export const Flag = ({ code, size = 24, ...rest }: FlagProps) => (
  <svg
    aria-hidden
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    {...rest}
  >
    {FLAGS[code]}
  </svg>
)

export type { FlagCode }
